export default __webpack_public_path__ + "static/media/outer-top-corners-rounded.e1d633de.webp";